import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Typography, useTheme } from '@material-ui/core';

// CONSTANTS
import { LOCATIONS_HOME_PARTNER_PAGE } from '@/constants/locations';

// STORE
import { AuthActions } from '@/store/actions';

// HOOKS
import useActions from '@/hooks/useActions';

// COMPONENTS
import MBIcon from '@/components/Icons/MBIcon';

// HELP
import { Container } from './styles';

const LeftSection = ({ partner }) => {
  const [t] = useTranslation();
  const theme = useTheme();

  const [manageAuthDialogState] = useActions([
    dialogProps => AuthActions.manageAuthDialogState.action({ state: true, props: dialogProps }),
  ]);

  return (
    <Container className="left-section welcome__left">
      <div>
        <Typography className="m-b-30" component="h1" variant="h2">
          {partner?.text_overwrites?.partner_not_registred_left_title ||
            t('partnerHomeAuth.welcome.left.title')}
        </Typography>
        <Button
          endIcon={<MBIcon />}
          color={theme.partnerStyles ? 'primary' : 'default'}
          location={LOCATIONS_HOME_PARTNER_PAGE}
          onClick={manageAuthDialogState}
        >
          {t('partnerHomeAuth.welcome.left.button')}
        </Button>
      </div>
    </Container>
  );
};

LeftSection.propTypes = {
  partner: PropTypes.object.isRequired,
};

export default React.memo(LeftSection);
